var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title"},[_vm._v("\n    "+_vm._s(_vm.$tr('learnOnlyDeviceLabel'))+"\n  ")]),_c('div',{staticClass:"notice"},[_vm._v("\n    "+_vm._s(_vm.$tr('learnOnlyDeviceNotice'))+"\n  ")])])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }